export default __webpack_public_path__ + "static/media/56-min.a0e82ffc.jpg";